<template>
  <div>
    <el-container>
      <el-header>
        <div style="margin: 10px 0">
          <el-input v-model="serchat" placeholder="请输入客户名称" maxlength="30" style="width: 300px;"></el-input>
          <el-dropdown split-button type="primary" @command="commandEvent">
            <span v-html="dropdownTitle"></span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="全部">全部</el-dropdown-item>
              <el-dropdown-item v-for="(item,index) in dropdownList" :key="index" :command="item.label">{{item.label}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button type="primary" @click="isAjax" plain>查询</el-button>
          <el-button circle @click="qieFun"><el-image :src="qiehuanIcon" style="width: 20px;height: 20px;vertical-align: middle;"></el-image></el-button>
        </div>
      </el-header>
      <el-main>
        <template>
          <el-table
            :data="tableData"
            show-summary
            :summary-method="getSummaries"
            border
            :height="divHeight"
            style="width: 100%">
            <el-table-column
              fixed
              prop="customerName"
              label="名称"
              width="150">
            </el-table-column>
            <!--<el-table-column
              prop="class"
              label="客户分类"
              width="120">
            </el-table-column>-->
            <el-table-column
              prop="order_total"
              sortable
              :sort-method="(a, b)=>{return a.order_total - b.order_total }"
              label="订单总金额"
              :formatter="formatterAmount"
              width="150">
            </el-table-column>
            <el-table-column
              prop="order_amount"
              sortable
              :sort-method="(a, b)=>{return a.order_amount - b.order_amount }"
              label="订单成交金额"
              :formatter="formatterAmount"
              width="150">
            </el-table-column>
            <el-table-column
              prop="order_number"
              sortable
              :formatter="formatterAmount"
              label="订单总数量"
              width="150">
            </el-table-column>
            <el-table-column
              prop="prescription_order_number"
              sortable
              :formatter="formatterAmount"
              label="处方单数量"
              width="150">
            </el-table-column>
            <el-table-column
              prop="shopping_order_number"
              sortable
              :formatter="formatterAmount"
              label="商城订单数量"
              width="150">
            </el-table-column>
            <el-table-column
              prop="store_number"
              sortable
              :formatter="formatterAmount"
              label="门店数量"
              width="150">
            </el-table-column>
            <el-table-column
              prop="member_number"
              sortable
              :formatter="formatterAmount"
              label="会员数量"
              width="150">
            </el-table-column>
            <el-table-column
              prop="doctor_number"
              sortable
              :formatter="formatterAmount"
              label="医生数量"
              width="150">
            </el-table-column>
            <el-table-column
              prop="patient_number"
              sortable
              :formatter="formatterAmount"
              label="患者数量"
              width="150">
            </el-table-column>
            <el-table-column
              prop="commodity_number"
              sortable
              :formatter="formatterAmount"
              label="商品数量"
              width="150">
            </el-table-column>
            <el-table-column
              prop="place_number"
              sortable
              :formatter="formatterAmount"
              label="下单客户数"
              width="150">
            </el-table-column>
            <el-table-column
              prop="place_order_time"
              :formatter="formatTime"
              label="最后下单时间"
              width="200">
            </el-table-column>
            <el-table-column
              prop="identification"
              label="标识"
              width="80">
            </el-table-column>
            <el-table-column
              prop="update_time"
              fixed="right"
              :formatter="formatTime"
              label="最后统计时间"
              width="200">
            </el-table-column>
          </el-table>
        </template>
      </el-main>
      <el-footer>
        <el-pagination
          background
          @size-change="handleSizeChange0"
          @current-change="handleCurrentChange0"
          :current-page="currentPage0"
          :page-sizes="[100, 200, 300, 400]"
          :page-size="count0"
          layout="total, sizes, prev, pager, next, jumper"
          :total="allcount0">
        </el-pagination>
      </el-footer>
    </el-container>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        qiehuanIcon: require('@/assets/qiehuan.png'),
        numtype: 'NUM',
        serchat:"",
        dropdownTitle:"请选择",
        tableData:[],
        allcount0:0,//总页数 对应 total
        count0:100,//一页显示多少量 对应 page-size
        currentPage0:1,//当前页数
        divHeight:500,
        dropdownList:[]
      }
    },
    methods:{
      formatterAmount(row, column, cellValue) {
        if (cellValue) {
          cellValue = parseFloat(cellValue).toFixed(2)
          cellValue = parseFloat(cellValue)
          if (this.$store.getters.getStoreNumtype === 'CN') {
            if (parseFloat(cellValue) > 9999) {
              const units = ['', '万', '亿', '十亿', '百亿', '千亿'];
              let num = Math.abs(cellValue);
              const uIndex = Math.floor(Math.log10(num) / 4); // 计算所使用的单位
              const result = (cellValue / Math.pow(10, 4 * uIndex)).toFixed(2) + units[uIndex];
              return result;
            } else {
              return parseFloat(cellValue).toFixed(2)
            }
          } else {
            return cellValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          }
        } else {
          return 0
        }
      },
      formatterAmount1(cellValue) {
        if (cellValue) {
          cellValue = parseFloat(cellValue).toFixed(2)
          cellValue = parseFloat(cellValue)
          if (this.$store.getters.getStoreNumtype === 'CN') {
            const units = ['', '万', '亿', '十亿', '百亿', '千亿'];
            let num = Math.abs(cellValue);
            const uIndex = Math.floor(Math.log10(num) / 4); // 计算所使用的单位
            const result = (cellValue / Math.pow(10, 4 * uIndex)).toFixed(2) + units[uIndex];
            return cellValue <= 0 ? 0 : result;
          } else {
            return cellValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          }
        } else {
          return 0
        }
      },
      formatTime:function(row, column) {
        var date = new Date(row[column.property]);
        var format = "yyyy-MM-dd hh:mm:ss";
        var o = {
          "M+" : date.getMonth()+1, //month
          "d+" : date.getDate(),    //day
          "h+" : date.getHours(),   //hour
          "m+" : date.getMinutes(), //minute
          "s+" : date.getSeconds(), //second
          "q+" : Math.floor((date.getMonth()+3)/3),  //quarter
          "S" : date.getMilliseconds() //millisecond
        };
        if(/(y+)/.test(format)) format=format.replace(RegExp.$1,
          (date.getFullYear()+"").substr(4 - RegExp.$1.length));
        for(var k in o)if(new RegExp("("+ k +")").test(format))
          format = format.replace(RegExp.$1,
            RegExp.$1.length==1 ? o[k] :
              ("00"+ o[k]).substr((""+ o[k]).length));
        return format;
      },
      commandEvent(command) {
        this.dropdownTitle = command
      },
      handleSizeChange0(val) {
        this.count0 = val;
        this.isAjax();
      },
      handleCurrentChange0(val) {
        this.currentPage0 = val;
        this.isAjax();
      },
      addClass:async function(){
        await this.$axios.post('/data/addClass',{
          uid:""
        }).then((response,err) => {
          response = response.data;
          if(response.code == "Login" || response.code == "WhiteList"){
            this.$message.error(response.message);
          }else if(response.code == "Success"){
            this.dropdownList = response.data[0];
          }else if(response.data.code == "Fail"){
            this.$message({
              message: response.message,
              type: 'warning'
            });
          }else{
            this.$message({
              message: response.message,
              type: 'warning'
            });
          }
        }).catch(function (error) {
          this.$message.error(error);
        });
      },
      qieFun: function () {
        this.$store.commit('setStoreNumtype', this.$store.getters.getStoreNumtype === 'NUM' ? 'CN' : 'NUM');
        this.isAjax()
      },
      isAjax:async function(){
        await this.$axios.post('/data/addRetailPurchaser',{
          d:this.dropdownTitle,
          s:this.serchat,
          "limit":this.count0,
          "page":this.currentPage0
        }).then((response,err) => {
          response = response.data;
          if(response.code == "Login" || response.code == "WhiteList"){
            this.$message.error(response.message);
          }else if(response.code == "Success"){
            this.tableData = response.data[0];
            this.allcount0 = response.data[1];
            this.divHeight = window.innerHeight-158;
          }else if(response.data.code == "Fail"){
            this.$message({
              message: response.message,
              type: 'warning'
            });
          }else{
            this.$message({
              message: response.message,
              type: 'warning'
            });
          }
        }).catch(function (error) {
          this.$message.error(error);
        });

      },
      getSummaries(param) {
        const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '合计';
            return;
          }
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] += '';
          } else {
            sums[index] = 'N/A';
          }
          if (index === 12 || index === 13 || index === 14) {
            sums[index] = 'N/A';
          }else {
            if (sums[index] && sums[index] !== 'N/A') {
              sums[index] = parseFloat(sums[index]).toFixed(2);
              sums[index] = this.formatterAmount1(sums[index])
            } else {
              sums[index] = 0
            }
          }
        });
        return sums;
      }
    },
    mounted(){
      this.$store.dispatch('loadData');
      this.addClass();
      this.isAjax();
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/dataRetailStatistics/summaryRetailData.vue